import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileCheck, Upload, CheckCircle2, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/documents").then(r => setDocs(r.data.documents));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/documents", { name, file_url: url });
      setName(""); setUrl("");
      toast.success("Document added"); load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to add document");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-10 pb-24">
      <div className="text-xs uppercase tracking-widest text-muted font-semibold">Documents</div>
      <h1 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">Every paper, in one place.</h1>
      <p className="mt-2 text-muted">A case handler will review each one before your consulate appointment.</p>

      <form onSubmit={add} className="mt-8 moe-card p-6 space-y-3">
        <div className="moe-field">
          <input required value={name} onChange={(e)=>setName(e.target.value)} placeholder=" " data-testid="doc-name"/>
          <label>Document name (e.g. Passport bio page)</label>
        </div>
        <div className="moe-field">
          <input value={url} onChange={(e)=>setUrl(e.target.value)} placeholder=" " data-testid="doc-url"/>
          <label>Link (optional. Drive or Dropbox link)</label>
        </div>
        <button disabled={busy} data-testid="doc-add" className="moe-btn moe-btn-primary">
          <Upload size={16}/> {busy ? "Adding…" : "Add document"}
        </button>
      </form>

      <div className="mt-8 space-y-3 moe-stagger">
        {docs.length === 0 && <div className="text-sm text-muted">No documents yet.</div>}
        {docs.map((d) => (
          <div key={d.id} className="moe-card p-4 flex items-center gap-3">
            <FileCheck size={18} className="text-elec" strokeWidth={2}/>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{d.name}</div>
              {d.file_url && <a href={d.file_url} target="_blank" rel="noreferrer" className="text-xs text-muted hover:text-elec truncate block">{d.file_url}</a>}
            </div>
            {d.review_status === "approved" ? (
              <span className="moe-chip moe-chip-mint"><CheckCircle2 size={12}/> Approved</span>
            ) : d.review_status === "rejected" ? (
              <span className="moe-chip moe-chip-pink">Rejected</span>
            ) : (
              <span className="moe-chip"><Clock size={12}/> Pending</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
